<div class="title-components">
  <h1>Historial de versiones</h1>
</div>

<div class="divider-butons-VH">
  <div (click)=" ToggleModalHelp(true)" class="btn btn-icon-text-left">
    <span class="text">Ayuda</span><i class="fa-regular fa-circle-question"></i>
  </div>
</div>


<div class="container-global-components ConVH">

  <div class="Table-Lib Table-container-Global">

    <p-table #dt [value]="List_Histrory_Version_FIN" [(selection)]="SelectedList_Histrory_Version_FIN" dataKey="id"
      [rowHover]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,15,25, 50]"
      [paginator]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      [filterDelay]="0"
      [globalFilterFields]="['Name','Purpose','Code','Revision_No','Approver1_Name','Approver2_Name','Approver3_Name','Approver4_Name','Contributor_Name']">


      <ng-template pTemplate="caption">

        <div class="SectionCreateTotal Table_NG">
          <div class="left-CT">

            <!--?===== INPUT FOR FIN SEARCH =====?-->
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Filter_VersionH" type="text"
                (input)="dt.filterGlobal(Filter_VersionH, 'contains')" placeholder="Buscar en historial de versiones" />
            </div>
          </div>
          <div class="right-CT">

          </div>
        </div>

      </ng-template>


      <ng-template pTemplate="header">

        <tr>

          <ng-container *ngFor="let Table_Header of HeadersVH">

            <ng-container *ngIf="Table_Header.Key_Header === 'DOWNF'">
              <th class="{{Table_Header.Key_Header}}">{{Table_Header.Name}}</th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMFI'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Name" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'ANNEX'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CODEF'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Code" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DESCR'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="text" field="Purpose" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NOREV'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Revision_No" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">No. Revisión</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Revision_No"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CONTR'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Contributor_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Contribuidor</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Contributor_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DACRE'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="date" field="Date_Created" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DAEXP'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter type="date" field="Date_End" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR1'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Approver1_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Mgr. Process Owner</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver1_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR2'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Approver2_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre RM & ICS Specialist</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver2_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR3'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Approver3_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre RM & ICS Sr. Mgr.</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver3_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR4'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Approver4_Name" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Nombre Finance Director or CFO</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" [options]="Filter_Global_Check.Approver4_Name"
                          placeholder="Seleccione" optionLabel="Value" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">

                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>{{option.Value}}</span>
                              </div>
                            </div>

                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'STATU'">
              <th class="{{Table_Header.Key_Header}}">
                <div class="Grid-Th">
                  <span>{{Table_Header.Name}}</span>
                  <span class="Icon-Th">
                    <p-columnFilter field="F_Status" matchMode="in" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false" class="ml-auto">
                      <ng-template pTemplate="header">
                        <div class="px-3 pt-3 pb-0">
                          <span class="font-bold">Estatus</span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-multiSelect [ngModel]="value" optionLabel="Value" [options]="Filter_Global_Check.Status"
                          placeholder="Seleccione" (onChange)="filter($event.value)">
                          <ng-template let-option pTemplate="item">
                            <div class="Icon-Table-File">
                              <div class="Content-Icon">
                                <span>
                                  <div [ngSwitch]="option.Value">
                                    <div *ngSwitchCase='1'>Aprobado</div>
                                    <div *ngSwitchCase='2'>Pendiente</div>
                                    <div *ngSwitchCase='3'>Rechazado</div>
                                    <div *ngSwitchDefault></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </ng-template>
                        </p-multiSelect>
                      </ng-template>
                    </p-columnFilter>
                  </span>

                </div>
              </th>
            </ng-container>

          </ng-container>

        </tr>

      </ng-template>


      <ng-template pTemplate="body" let-List_Histrory_Version_FIN let-i="rowIndex">

        <tr>

          <td *ngFor="let Table_Header of HeadersVH">

            <ng-container *ngIf="Table_Header.Key_Header === 'DOWNF'">
              <button (click)="Check_Version_FIN(List_Histrory_Version_FIN,i)"
              [disabled]="!(UserRoleIn([PermissionFIN.downloadVersionFlow]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]))"
                class="Btn-Download-Local Btn-Download-Global" id="Btn-Download{{i}}">
                <div class="Content-Download">
                  <span class="Progress-Bar-Task" id="Progress-Bar-Task{{i}}"></span>
                  <span class="Btn-Text" id="Text-Btn{{i}}">{{(UserRoleIn([PermissionFIN.downloadVersionFlow]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])) ?
                    'Descargar':'Sin Permisos'}}</span>
                  <i class="fa-solid fa-cloud-arrow-down" id="Icon-Btn{{i}}"></i>
                </div>
              </button>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NAMFI'">
              {{List_Histrory_Version_FIN.Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'ANNEX'">
              <div class="Container-Annexe">

                <button [disabled]="List_Histrory_Version_FIN.Annexes.length === 0 || !(UserRoleIn([PermissionFIN.versionHistoryAnnexe]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]))"
                  (click)="Can_See_Modal_Annexe(List_Histrory_Version_FIN)"
                  class="Btn-Annexe {{Contain_Annexe(List_Histrory_Version_FIN.Annexes)}}">
                  <ng-container *ngIf="List_Histrory_Version_FIN.Annexes.length===0">
                    <i class="fa-solid fa-question"></i>
                  </ng-container>

                  <ng-container *ngIf="List_Histrory_Version_FIN.Annexes.length>0">
                    <i class="fa-regular fa-paste"></i>
                  </ng-container>

                  <div class="Tool-Tip T-Annexe {{Contain_Annexe(List_Histrory_Version_FIN.Annexes)}}">
                    {{Contain_Annexe_Text(List_Histrory_Version_FIN.Annexes)}}</div>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CODEF'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Code(List_Histrory_Version_FIN.Code)}}
                </div>

                <button (click)="See_Code(List_Histrory_Version_FIN.Code)"
                  *ngIf="List_Histrory_Version_FIN.Code.length > 15" class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver Código</div>
                </button>

              </div>

            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DESCR'">
              <div class="Description">

                <div class="Text-Description">
                  {{Cut_Purpose(List_Histrory_Version_FIN.Purpose)}}
                </div>

                <button (click)="See_Purpose(List_Histrory_Version_FIN.Purpose)"
                  *ngIf="List_Histrory_Version_FIN.Purpose.length > 32" class="Btn-Description">
                  <i class="fa-regular fa-file-lines"></i>
                  <div class="Tool-Tip T-Description">Ver objetivo</div>
                </button>

              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'NOREV'">
              {{List_Histrory_Version_FIN.Revision_No}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'CONTR'">
              {{List_Histrory_Version_FIN.Contributor_Name}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DACRE'">
              {{DateFormat(List_Histrory_Version_FIN.Date_Created)}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'DAEXP'">
              {{DateFormat_Approved(List_Histrory_Version_FIN.Date_End,List_Histrory_Version_FIN.Status)}}
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR1'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin(List_Histrory_Version_FIN,1)" (click)="SeeReason_Approver(List_Histrory_Version_FIN,1)"
                  class="Icon-Status Status{{List_Histrory_Version_FIN.TaskApprover1.Status}}">
                  <div><i class="fa-solid {{Icons[List_Histrory_Version_FIN.TaskApprover1.Status].Icon}}"></i></div>
                  <span *ngIf="SeeToolTip_Rejected_Approver(List_Histrory_Version_FIN,1)" class="Tool-Tip">Ver razón de
                    rechazo</span>
                    <span *ngIf="SeeToolTip_Approved_Admin(List_Histrory_Version_FIN,1)" class="Tool-Tip">Ver usuario aprobador</span>
                </div>
                <span class="Name"> {{Get_Name_Approver(List_Histrory_Version_FIN.Approver1_Name)}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR2'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin(List_Histrory_Version_FIN,2)" (click)="SeeReason_Approver(List_Histrory_Version_FIN,2)"
                  class="Icon-Status Status{{List_Histrory_Version_FIN.TaskApprover2.Status}}">
                  <div><i class="fa-solid {{Icons[List_Histrory_Version_FIN.TaskApprover2.Status].Icon}}"></i></div>
                  <span *ngIf="SeeToolTip_Rejected_Approver(List_Histrory_Version_FIN,2)" class="Tool-Tip">Ver razón de
                    rechazo</span>
                    <span *ngIf="SeeToolTip_Approved_Admin(List_Histrory_Version_FIN,2)" class="Tool-Tip">Ver usuario aprobador</span>
                </div>
                <span class="Name"> {{Get_Name_Approver(List_Histrory_Version_FIN.Approver2_Name)}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR3'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin(List_Histrory_Version_FIN,3)" (click)="SeeReason_Approver(List_Histrory_Version_FIN,3)"
                  class="Icon-Status Status{{List_Histrory_Version_FIN.TaskApprover3.Status}}">
                  <div><i class="fa-solid {{Icons[List_Histrory_Version_FIN.TaskApprover3.Status].Icon}}"></i></div>
                  <span *ngIf="SeeToolTip_Rejected_Approver(List_Histrory_Version_FIN,3)" class="Tool-Tip">Ver razón de
                    rechazo</span>
                    <span *ngIf="SeeToolTip_Approved_Admin(List_Histrory_Version_FIN,3)" class="Tool-Tip">Ver usuario aprobador</span>
                </div>
                <span class="Name"> {{Get_Name_Approver(List_Histrory_Version_FIN.Approver3_Name)}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'APPR4'">
              <div class="Status-Task">
                <div (click)="seeApproverAdmin(List_Histrory_Version_FIN,4)" (click)="SeeReason_Approver(List_Histrory_Version_FIN,4)"
                  class="Icon-Status Status{{List_Histrory_Version_FIN.TaskApprover4.Status}}">
                  <div><i class="fa-solid {{Icons[List_Histrory_Version_FIN.TaskApprover4.Status].Icon}}"></i></div>
                  <span *ngIf="SeeToolTip_Rejected_Approver(List_Histrory_Version_FIN,4)" class="Tool-Tip">Ver razón de
                    rechazo</span>
                    <span *ngIf="SeeToolTip_Approved_Admin(List_Histrory_Version_FIN,4)" class="Tool-Tip">Ver usuario aprobador</span>
                </div>
                <span class="Name"> {{Get_Name_Approver(List_Histrory_Version_FIN.Approver4_Name)}}</span>
              </div>
            </ng-container>

            <ng-container *ngIf="Table_Header.Key_Header === 'STATU'">
              <div class="ContainerStatus">
                <div class="StatusTool S{{List_Histrory_Version_FIN.Status}}"></div>
                {{Status_string(List_Histrory_Version_FIN.Status)}}
              </div>
            </ng-container>

          </td>

        </tr>

      </ng-template>

    </p-table>

  </div>

</div>







<!---===================== MODAL FOR HELP ICONS =====================--->
<section class="Modal-Global" id="ModalIconsHelp">
  <div class="wrapper">
    <div class="Local-M-Icon-Popup popup">
      <div class="Local-M-Icon-inside popup-inside">
        <div class="Local-M-Icon-backgrounds backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Local-M-Icon-content content">
        <div (click)=" ToggleModalHelp(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></div>
        <div class="Content-Top">
          <h2>Iconografía</h2>
        </div>

        <div class="Content-body">
          <div class="Info-Icons">
            <div class="Header grid-column-2">
              <div class="Icon-container">
                Icono
              </div>
              <div class="Description">
                Descripción
              </div>
            </div>
            <div *ngFor="let icon of Icons;let i = index" class="grid-column-2">
              <div class="Icon-container">
                <div class="Icon-Status Status{{i}}">
                  <div><i class="fa-solid {{Icons[i].Icon}}"></i></div>
                </div>
              </div>
              <div class="Description">
                {{icon.Description}}
              </div>
            </div>

          </div>
        </div>
        <div class="Local-M-Icon-Bottom Content-Bottom">
          <div (click)=" ToggleModalHelp(false)" class="Btn-Close-Modal">
            <span>Cerrar</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<!---===================== MODAL FOR SEE ANNEXES =====================--->
<section class="Modal-Global" id="Modal-See-Annexe">
  <div class="wrapper">
    <div class="Pro-popup-See-Annexes1 popup">
      <div class="Pro-inside-See-Annexes1 popup-inside">
        <div class="Pro-backgrounds-See-Annexes1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Pro-content-See-Annexes1 content">
        <button (click)="Modal_See_Annexe(false)" class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Anexos</h2>
          <h4>Anexos de {{FFIN_Select_CM.Name}}</h4>
        </div>

        <div class="Content-body">

          <div class="Container-Annexes Container-Annexes-See">
            <div class="Container-Card-Annexes">

              <div *ngFor="let Annexe of FFIN_Select_CM.Annexes" class="Card-Annexes">

                <div class="Container-File">
                  <ng-container *ngFor="let icon of Icons_Image">
                    <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                      <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                    </div>
                  </ng-container>
                  <div class="Name-Annexe">
                    {{CutNameFile(Annexe.Name,35)}}
                  </div>
                </div>

                <div class="Container-Buttons-Annexe">
                  <button *ngIf="UserRoleIn([PermissionFIN.downloadVersionAnnexe]) || UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN])" (click)="Can_Download_Annexe(Annexe)" type="button" class="button-square">
                    <i class="fa-solid fa-download"></i>
                  </button>
                </div>


              </div>

            </div>
          </div>

          <div class="Container-Download-Annexe" id="Container-Download-Annexe">
            <div class="Container-progress-bar-Annexe">
              <span class="Progress-Bar-Annexe" id="Progress-Bar-Annexe"></span>
            </div>
          </div>

        </div>
        <div class="Content-Bottom Bottom-Modal-See-Annexe">
          <button (click)="Modal_See_Annexe(false)" class="Btn-Close-Modal ">
            <span>Cerrar</span>
          </button>

        </div>
      </div>

    </div>
  </div>
</section>

<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
